export default "__VITE_ASSET__TmbfZ2wO__"